import { ManagersList } from 'src/models/employerManagersPage';

import { getIsManagerMCP } from 'src/components/HiringManager/utils/getIsManagerMCP';

export const getIsExpandedVacancyPermissions = (managers: ManagersList[]): boolean =>
    managers.length ? managers.some((manager) => !getIsManagerMCP(manager)) : false;
